import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataTableComponent, ExgTableSettingsComponent} from 'exc-controls-v2';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-report-list', templateUrl: './report-list.component.html', styles: [],
})
export class ReportListComponent extends ExcTranslation implements OnInit, AfterViewInit {
  /****************************/
  @ViewChild('VCreportTable', {read: ExgDataTableComponent}) VCreportTable!: ExgDataTableComponent;
  @ViewChild('VCreportTableFilterControl', {read: ExgFilterComponent}) VCreportTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCreportTableSortControl', {read: ExgFilterComponent}) VCreportTableSortControl!: ExgFilterComponent;
  @ViewChild('VCreportTableSearchControl', {read: ExgFilterComponent}) VCreportTableSearchControl!: ExgFilterComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  @ViewChild('VCFilterChips', { read: ExgFilterChipsComponent }) VCFilterChips!: ExgFilterChipsComponent;
  /****************************/
  init = true;
  reportTable = {
    selectKey: 'fbaID',
    newV2Table: false,
    prefilterObject: {order: 8, caption: 'Aktive - Alle', value: 0},
    prefilter: 0,
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilterEnumGroup: [
      { enmTable: 'FragebogenAusgefuellt', enmName: 'FragebogenAusgefuelltStatus', enmField: 'fbaFragebogenAusgefuelltStatus_enmIdent' },
      { enmTable: 'AuftragE_EIS', enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmAlt: false,
        enmAltTT: true},
      { enmTable: 'Vorgang', enmName: 'VorgangStatus', enmField: 'vorg_enmIdent_VorgangStatus', },
      { enmTable: 'Vorgang', enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', },
      // {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ], uiFilterSearchFields: [
      {table: 'FragebogenAusgefuellt', tableField: 'fbaName'},
      {table: 'FragebogenAusgefuellt', tableField: 'fbaVersion'},
      {table: 'FragebogenAusgefuellt', tableField: 'vorgNr'},
      {table: 'FragebogenAusgefuellt', tableField: 'fbaCRD'},
      {table: 'FragebogenAusgefuellt', tableField: 'fbaCRD'},
      {table: 'Vorgang', tableField: 'vorgNr'},
      {table: 'Vorgang', tableField: 'Bearbeiter'},
      {table: 'Vorgang', tableField: 'Bearbeiter_Handy'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {table: 'All', tableField: 'vorgLCU', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgLCD', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgCKD', groupCaption: 'Vorgang'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenNr', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueVersicherungsnehmer', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenOrt', groupCaption: 'Schaden'},
      {table: 'Auftrag', tableField: 'auAuftraggeberShort', repColumn: 'au_oeID_Auftraggeber'},
      {table: 'Auftrag', tableField: 'auAnsprechpartner'},
    ], uiSortFieldGroup: [
      { fieldGroup: 'FragebogenAusgefuellt', fieldTable: 'All', fieldName: 'fbaCRD', uiName: '%CRD' },
      { fieldGroup: 'FragebogenAusgefuellt', fieldTable: 'All', fieldName: 'fbaCRD', uiName: '%LCD' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'All', fieldName: 'apiLCD', uiName: '%LCD' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'All', fieldName: 'apiLCD', uiName: '%LCD' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiLCD', uiName: '%CRD' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiLCD', uiName: '%LCD' },
      { fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist' },
      { fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD', uiName: '%LCD' },
      { fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD', uiName: '%CRD' },
      { fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD', uiName: '%CKD' },
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      { fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType))
        .filter((filters: any) => (filters.uiValue === true && filters.filterType === 1)
          || (filters.filterCondition.value.length > 0 && filters.filterType === 2));
    },
    data: [] as any[],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0,
    },
    isLoading: true,
    ready: () => {
      if (!this.reportTable.data || this.reportTable.data.length === 0) {
        this.reportTable.state = 2;
        if (this.VCreportTable) {
          this.VCreportTable.selectedRow = -1;
        }
      } else {
        this.reportTable.state = 0;
        if (this.VCreportTable) {
          this.VCreportTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.reportTable.isLoading = false;
      this.tableIsLoading.next(this.reportTable.isLoading);
    },
    selectionChanged: (index: number) => {
      this.reportTable.selectedRow = this.reportTable.data[index];
      this.tableIsLoading.next(false);
    },
    dblClick: (index: number) => {
      this.reportTable.selectionChanged(index);
      this.VCreportTable.selectedRow = index;
      this.openReference();
    },
    pageChanged: (page: number) => {
      if (this.reportTable.MetaInfo.dataPaging !== undefined) {
        this.reportTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.reportTable.loadData();
    },
    search: (value: string) => {
      this.reportTable.searchValue = value;
      this.reportTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.reportTable.state = 1;
      SELF.reportTable.isLoading = true;
      this.tableIsLoading.next(SELF.reportTable.isLoading);
      SELF.excRest
        .sget(SELF.excRest.computeUrl('ReportR_List', {
          filter: this.reportTable.prefilter, fts: this.reportTable?.searchValue,
        }), 'MessageListState', {
          MetaInfo: {
            dataPaging: this.reportTable.MetaInfo.dataPaging,
            dataSort: this.reportTable.MetaInfo.dataSort,
            dataFilter: this.reportTable.MetaInfo.dataFilter
          }
        })
        .subscribe((response) => {
          if (response.success && response.data) {
            SELF.reportTable.data = response.data.Reports;
            SELF.reportTable.paging = response.paging.Reports;
          } else {
            SELF.reportTable.data = [];
            SELF.reportTable.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.reportTable.ready();
          this.VCFilterChips?.workspace.computeMetaInfo(this.appSvc.helperObj.clone(this.reportTable.MetaInfo));
        });
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.reportTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRest
        .sget(
          this.excRest.computeUrl('ReportR_List', {
            filter: this.reportTable.prefilter, fts: this.reportTable?.searchValue,
          }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.reportTable.MetaInfo}
        ).subscribe((ret: any) => {
        // console.log(ret.data);
        this.reportTable.distinctData = ret.data;
      });
    },
    isFiltered: () => {
      return (this.reportTable.MetaInfo.dataFilter && JSON.stringify({}) !== JSON.stringify(this.reportTable.MetaInfo.dataFilter));
    },
  };

  tableIsLoading = new BehaviorSubject(this.reportTable.isLoading);

  constructor(
    private chDecRef: ChangeDetectorRef,
    public excRest: ExcRestService,
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService) {
    super();
    setInterval(() => {
      this.chDecRef.detectChanges();
    }, 15);
  }

  ngOnInit(): void {
    this.registerEvents();
    this.initEnumerations();
    this.initTableDefinition();
  }

  ngAfterViewInit(): void {
    this.VCreportTableFilterControl.ApplyFilter();
  }

  initEnumerations(): void {
    this.reportTable.uiFilter = this.appSvc.metaInfo.dataFilter(this.reportTable.uiFilterEnumGroup, this.reportTable.uiFilterSearchFields);
    this.reportTable.uiSort = this.appSvc.metaInfo.dataSort(this.reportTable.uiSortFieldGroup);
  }

  initTableDefinition(): void {
    this.reportTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgNr')
        , value: 'vorgNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        , value: 'aueSchadenNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('FragebogenAusgefuellt', 'fbaStatus')
        , value: 'fbaFragebogenAusgefuelltStatus_enmIdent'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('FragebogenAusgefuelltStatus', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('FragebogenAusgefuellt', 'fbaName')
        , value: 'fbaName'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('FragebogenAusgefuellt', 'fbaVersion')
        , value: 'fbaVersion'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'auAuftraggeber')
        , value: 'auAuftraggeber'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')
        , value: 'aueVersicherungsnehmer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragTyp')
        , value: 'au_enmIdent_AuftragTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('AuftragTyp', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')
        , value: 'vorg_enmIdent_VorgangTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value ? this.enumSvc.getEnumerationText('VorgangTyp', value) : ' - ';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')
        , value: 'aueSchadenOrt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')
        , value: 'aue_enmIdent_SchadenArt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Schadenart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')
        , value: 'aue_enmIdent_Versicherungsart'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Versicherungsart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_oid_Bearbeiter')
        , value: 'vorgBearbeiter'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CRU')
        , value: 'fbaCRU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CRD')
        , value: 'fbaCRD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCU')
        , value: 'fbaLCU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCD')
        , value: 'fbaLCD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
    ];
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.reportTable.loadData();
    });
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.initEnumerations();
      this.initTableDefinition();
    });
    this.tableIsLoading.subscribe(async (value) => {
      this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 1000));
        this.chDecRef.detach();
      }
    });
  }
  openReference(): void {
    window.open(this.excRest.computeUrl('ReportModuleOpenReport', {
      fbaID: this.reportTable.selectedRow.fbaID,
    }), '_blank');
  }

  openTableSettings($event: any): void {
    if (this.reportTable.newV2Table) {
      this.VCtableDefinitionSettings.openFilterConfig($event);
    }
  }
}
